<template>
    <a-drawer
      :title="'著作信息-'+actionName"
      placement="right"
      :closable="false"
      :visible="visible"
      @close="onClose"
      width="30%"
    >
        <div class="input-box">
            <p>标题：</p>
            <a-input class="input" v-model="info.title" :disabled="actionName=='查看'"/>
        </div>
        <div class="input-box">
            <p>类型：</p>
            <a-select class="input" allowClear v-model="info.type" :disabled="actionName=='查看'">
                <a-select-option v-for="(item,index) in zzlxArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
            </a-select>
        </div>
        <div class="input-box">
            <p>作者：</p>
            <a-input class="input" :disabled="actionName=='查看'" v-model="info.author" />
        </div>
        <div class="input-box">
            <p>年度：</p>
            <a-date-picker 
                class="input" 
                mode='year'
                format='YYYY年'
                :open='yearShowOne'
                v-model="info.year" 
                @openChange="openChangeOne"
                @panelChange="panelChangeOne" 
                :disabled="actionName=='查看'"/>
        </div>
        <div class="input-box">
            <p>版本：</p>
            <a-input class="input" :disabled="actionName=='查看'" v-model="info.version" />
        </div>
        <div class="input-box">
            <p>出版社：</p>
            <a-input class="input" :disabled="actionName=='查看'" v-model="info.publishCompany" />
        </div>
        <div class="input-box">
            <p>出版地：</p>
            <a-input class="input" :disabled="actionName=='查看'" v-model="info.publishPlace" />
        </div>
        <div class="input-box">
            <p>总字数：</p>
            <a-input-number class="input" :disabled="actionName=='查看'" v-model="info.wordTotal" />
        </div>
        <div class="input-box">
            <p>ISBN：</p>
            <a-input class="input" :disabled="actionName=='查看'" v-model="info.isbn" />
        </div>
        <div class="btn-box">
            <a-button type="primary" @click="sub" v-if="actionName!='查看'">提交</a-button>
            <a-button @click="onClose">取消</a-button>
        </div>
    </a-drawer>
</template>

<script>
    import { getDicts } from '@/baseAPI/dictionary'
    import { add,update,info } from '@/baseAPI/research/book'
    import { getTeacher } from '@/baseAPI/facultyTeacher'
    export default {
        name: '',
        components: {
        },
        computed: {},
        data() {
            return {
                actionName:'',
                visible:false,
                id:'',
                info:{
                    title:null,
                    type:null,
                    author:null,
                    year:null,
                    version:null,
                    publishCompany:null,
                    publishPlace:null,
                    wordTotal:null,
                    isbn:null
                },
                zzlxArr:[],
                jsArr:[],
                yearShowOne:false,
            }
        },
        mounted () {
        },
        methods:{
            getInfo(){
                getDicts({dataCode:'ZZLX',status:true}).then(res=>{
                    this.zzlxArr=res.data.dicts;
                    this.info.type=res.data.defaultValue[0]
                })
                if(this.actionName!='新增'){
                    info(this.id).then(res=>{
                        this.info=res.data;
                    })
                }
            },
            showDrawer(name,id){
                this.id=id;
                this.actionName=name;
                this.getInfo();
                this.visible=true;
            },
            onClose() {
                this.info={
                    title:null,
                    type:null,
                    author:null,
                    year:null,
                    version:null,
                    publishCompany:null,
                    publishPlace:null,
                    wordTotal:null,
                    isbn:null
                };
                this.visible = false;
                this.$parent.fetch()
            },
            handSearch(value){
                if(value!=''){
                    this.info.consProjectTypeCode=value
                }
            },
            filterOption(input, option) {
                return (
                    option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                );
            },
            sub(){
                var isSub=true;
                var arr=['title','type','author','year','version','publishCompany','publishPlace','wordTotal','isbn']
                for(let key in this.info){
                    if(arr.indexOf(key)>-1){
                        if(this.info[key]==null||this.info[key]===''){
                            isSub=false;
                            break;
                        }
                    }
                }
                if(isSub){
                    if(this.actionName=='新增'){
                        add(this.info).then(res=>{
                            if(res.data.success){
                                this.$notification['success']({
                                    message: '成功',
                                    description:'新增著作成功',
                                });
                                this.onClose()
                            }else{
                                this.$notification['error']({
                                    message: '失败',
                                    description:res.data.errorMessage,
                                });
                            }
                        })
                    }else{
                        update(this.info).then(res=>{
                            if(res.data.success){
                                this.$notification['success']({
                                    message: '成功',
                                    description:'修改著作成功',
                                });
                                this.onClose()
                            }else{
                                this.$notification['error']({
                                    message: '失败',
                                    description:res.data.errorMessage,
                                });
                            }
                        })
                    }
                }else{
                    this.$notification['warning']({
                        message: '警告',
                        description:'请填写完整！',
                    });
                }
            },
            teacherSearch(value){
                getTeacher({teacherName:value}).then(res=>{
                    this.jsArr=res.data;
                })
            },
            teacherChange(value){
                for(let i=0;i<this.jsArr.length;i++){
                    if(this.jsArr[i].teacherId==value){
                        this.info.courseDirectorName=this.jsArr[i].teacherName
                    }
                }
            },
            openChangeOne(status) {
                if (status){
                    this.yearShowOne =  true
                }
            },
            // 得到年份选择器的值
            panelChangeOne(value) {
                this.info.year = this.getTimeStr(value._d,'yyyy');
                this.yearShowOne = false;
            }

        }
    }
</script>

<style scoped>
    .ant-drawer >>> .ant-drawer-header{
        background-color: #245086;
        border-radius: 0;
    }
    .ant-drawer >>> .ant-drawer-title{
        color: #fff;
        font-weight: bold;
        letter-spacing: 1px;
        font-size: 1.1rem;
    }
    .input-box{
        display: flex;
        line-height: 32px;
        margin-bottom: 1.5rem;
        position: relative;
    }
    .input-box p{
        width: 8rem;
        text-align: right;
    }
    .input-box .input{
        width: calc(100% - 8rem);
    }
    .input-box .tips{
        width: calc(100% - 8rem);
        position: absolute;
        right: 0;
        top: 100%;
        font-size: 13px;
        line-height: 20px;
        color: #1890ff;
    }
    .btn-box{
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        text-align: right;
        padding-bottom: 1rem;
        background-color: #fff;
    }
    .btn-box .ant-btn{
        margin-right: 2rem;
    }
    .input>>>.ant-input[disabled],.ant-input[disabled],.ant-select-disabled,.ant-input-number-disabled{
        color: rgba(0, 0, 0, 0.65);
        background-color: transparent;
    }
    .ant-select-disabled >>> .ant-select-selection{
        background-color: transparent;
    }

</style>
